import { getExperiment } from '@eventbrite/statsig';
import React, { useEffect, useState } from 'react';
import {
    LISTING_DEFAULT_PROFILE_PICTURE,
    LISTING_HEAP_PAGE_AREA_IDS,
} from '../../constants';
import { ReportThisEventButton } from '../ReportThisEvent/ReportThisEventButton';
import {
    DescriptiveOrganizerInfo,
    DescriptiveOrganizerInfoProps,
} from '../_shared/OrganizerInfo/DescriptiveOrganizerInfo';
import { checkForOrganiserNameCondition } from '../_shared/OrganizerInfo/helperFunctions';
import { OrganiserDetailDefaultImageVariant } from '../_shared/OrganizerInfo/OrganiserDetailDefaultImageVariantCard/OrganiserDetailDefaultImageVariants';
import './OrganizerPanel.scss';

export type OrganizerPanelLayoutProps = {
    shouldShowMoreEventsFromThisOrganizer?: boolean;
    isSalesEnded?: boolean;
    isSoldOut?: boolean;
    timeframeInMonths?: string;
    numberOfEvents?: string;
    trustSignal?: React.ReactNode;
    eventId?: string;
};

export const OrganizerPanelLayout = ({
    shouldShowMoreEventsFromThisOrganizer,
    captchaKey,
    eventName,
    gaCategory,
    isAuthenticated,
    organizerAvatar,
    organizerDescription,
    organizerId,
    organizerName,
    organizerUrl,
    organizerFacebook,
    organizerTwitter,
    organizerWebsite,
    isSalesEnded,
    isSoldOut,
}: OrganizerPanelLayoutProps & DescriptiveOrganizerInfoProps) => {
    const [showVariantType, setVariantType] = useState('control');
    useEffect(() => {
        if (!organizerAvatar && checkForOrganiserNameCondition(organizerName)) {
            const variant = getExperiment(
                LISTING_DEFAULT_PROFILE_PICTURE.experimentName,
                LISTING_DEFAULT_PROFILE_PICTURE.param,
                LISTING_DEFAULT_PROFILE_PICTURE.defaultValue,
            );
            setVariantType(variant);
        }
    }, [organizerAvatar, organizerName]);

    return (
        <section className="listing-organizer eds-l-pad-bot-5">
            {showVariantType === 'control' && (
                <DescriptiveOrganizerInfo
                    captchaKey={captchaKey}
                    organizerAvatar={organizerAvatar}
                    organizerDescription={organizerDescription}
                    organizerId={organizerId}
                    organizerName={organizerName}
                    organizerUrl={organizerUrl}
                    organizerFacebook={organizerFacebook}
                    organizerTwitter={organizerTwitter}
                    organizerWebsite={organizerWebsite}
                    isAuthenticated={isAuthenticated}
                    eventName={eventName}
                    gaCategory={gaCategory}
                    pageArea={LISTING_HEAP_PAGE_AREA_IDS.ORGANIZER_PANEL}
                />
            )}

            {(showVariantType === 'variant-b' ||
                showVariantType === 'variant-a') && (
                <OrganiserDetailDefaultImageVariant
                    captchaKey={captchaKey}
                    organizerDescription={organizerDescription}
                    organizerId={organizerId}
                    organizerName={organizerName}
                    organizerUrl={organizerUrl}
                    organizerFacebook={organizerFacebook}
                    organizerTwitter={organizerTwitter}
                    organizerWebsite={organizerWebsite}
                    isAuthenticated={isAuthenticated}
                    eventName={eventName}
                    gaCategory={gaCategory}
                    pageArea={LISTING_HEAP_PAGE_AREA_IDS.ORGANIZER_PANEL}
                    variantType={showVariantType}
                />
            )}
            <div className="eds-align--center eds-l-mar-bot-3">
                <ReportThisEventButton />
            </div>
            {shouldShowMoreEventsFromThisOrganizer &&
                (!isSalesEnded || !isSoldOut) && (
                    <div id="listings-root__more-events-from-this-organizer"></div>
                )}
            {(!isSalesEnded || !isSoldOut) && (
                <div id="listings-root__collections-related-to-this-event"></div>
            )}
        </section>
    );
};
